import { ICoreContext, IDateFormatOptions } from '@msdyn365-commerce/core';

export const formatDate = (context: ICoreContext, date: Date | undefined) => {
    if (date === undefined) {
        return '';
    }

    const dateOptions: IDateFormatOptions = { year: 'numeric', month: '2-digit', day: '2-digit' };
    return context.cultureFormatter.formatDate(date, dateOptions);
};

export const getDatePlaceholder = (context: ICoreContext): string => {
    const locale = (context.cultureFormatter as { locale?: string })?.locale ?? context.request.locale ?? '';
    const lang = locale.toLowerCase().split('-')[0];

    switch (lang) {
        case 'fr':
            return 'JJ.MM.AAAA';
        case 'en':
            return 'MM/DD/YYYY';
        default:
            return 'TT.MM.JJJJ';
    }
};

export const isSameDay = (dateA: Date, dateB: Date): boolean => {
    return dateA.getFullYear() === dateB.getFullYear() && dateA.getMonth() === dateB.getMonth() && dateA.getDate() === dateB.getDate();
};
